'use client';
import React from 'react';
import AccessorySlider from './_AccessorySlider';
import AccessoryGrid from './_AccessoryGrid';
import AccessoryScroll from './_AccessoryScroll';
import { MediaType } from '@repo/ui/src/types/image';
import { ToutContentProps } from '@repo/ui/src/types/toutContent';
import { ToutContent } from '@repo/ui/src/components/ToutContent/_toutContent';
import { useIsMobile } from '@repo/ui/src/utils/useMediaQuery';
import { classNames } from '@repo/ui/src/utils/classNames';
import { appConfig } from '../../utils/appConfig';

interface CustomizeProps {
  headerTout: ToutContentProps;
  video: MediaType;
  showVideo: boolean;
  order: number;
  _testID?: string;
  background: string;
  reverse?: boolean;
  accessories: Array<{
    toutContent: ToutContentProps;
    img: {
      image: MediaType;
      altTag: string;
    };
    video?: MediaType;
  }>;
}

const CustomizeAccessories = ({
  headerTout,
  video,
  accessories,
  order,
  _testID,
  background,
  reverse,
}: CustomizeProps) => {
  const smAndDown = useIsMobile();
  const darkGray = background === 'Dark Gray';

  return (
    <section
      className="tw-relative tw-overflow-hidden"
      style={{ zIndex: order || 'initial' }}
      data-test-id={`customize_accessories_${_testID}`}
    >
      {video && (
        <AccessoryScroll
          headingLight={headerTout.headingLight}
          heading={headerTout.heading}
          align="left"
          description={headerTout.description}
          video={video as MediaType}
        />
      )}
      <div className={classNames('tw-py-20', darkGray ? 'tw-bg-neutral-700' : 'tw-bg-neutral-800')}>
        {!video && (
          <div className="tw-max-w-[1680px] tw-mx-auto">
            <div className="tw-relative tw-flex tw-items-end tw-px-6 tw-pb-8 md:tw-px-12 md:tw-pb-12">
              <ToutContent
                headingLight={headerTout.headingLight}
                heading={headerTout.heading}
                align="left"
                headingStyleVariant={appConfig.isTraeger ? 'h1' : 'h2'}
                divider={appConfig.isTraeger}
                fullWidth={appConfig.isMeater}
                dark
                description={headerTout.description}
                className={
                  appConfig.isMeater &&
                  "[&_h2]:tw-w-fit [&_h2]:tw-uppercase [&_h2]:after:tw-content-[''] [&_h2]:after:tw-block [&_h2]:after:tw-w-full [&_h2]:after:tw-h-1 [&_h2]:after:tw-bg-brand-300 [&_h2]:after:tw-mt-6 [&_h2]:after:tw-mx-auto"
                }
              />
            </div>
          </div>
        )}
        {smAndDown && !appConfig.isMeater ? (
          <AccessorySlider accessories={accessories} />
        ) : (
          <AccessoryGrid accessories={accessories} reverse={reverse} />
        )}
      </div>
    </section>
  );
};

export default CustomizeAccessories;
